var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-indicator-rect"},[_c('div',{class:_vm.rectClassName},[_vm._v(" 0 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }